import { render, staticRenderFns } from "./AddWallet.vue?vue&type=template&id=0ae4aa0b&scoped=true&"
import script from "./AddWallet.vue?vue&type=script&lang=js&"
export * from "./AddWallet.vue?vue&type=script&lang=js&"
import style0 from "./AddWallet.vue?vue&type=style&index=0&id=0ae4aa0b&lang=scss&scoped=true&"
import style1 from "./AddWallet.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae4aa0b",
  null
  
)

export default component.exports